'use client'
import {
  createInstance,
  MatomoProvider as JonkoopsMatomoProvider,
  useMatomo,
} from '@jonkoops/matomo-tracker-react'
import { FC, PropsWithChildren, useMemo } from 'react'

const matomoUrl = process.env.NEXT_PUBLIC_MATOMO_URL
const matomoSiteId = process.env.NEXT_PUBLIC_MATOMO_SITE_ID
const isMatomoDisabled = process.env.NODE_ENV !== 'production'

// Store tracker instance to avoid recreating it
let matomoTrackerInstance: ReturnType<typeof createInstance> | null = null

const getMatomoTracker = () => {
  if (!matomoUrl) return null
  if (!matomoTrackerInstance) {
    matomoTrackerInstance = createInstance({
      urlBase: matomoUrl,
      siteId: parseInt(matomoSiteId || '0'),
      disabled: isMatomoDisabled,
      heartBeat: {
        active: true,
      },
      linkTracking: false,
    })
  }
  return matomoTrackerInstance
}

// Module-level guard to prevent enableLinkTracking from being called multiple times
let linkTrackingEnabled = false

const MatomoTracking: FC<PropsWithChildren> = ({ children }) => {
  const { enableLinkTracking } = useMatomo()

  if (!linkTrackingEnabled) {
    enableLinkTracking()
    linkTrackingEnabled = true
  }

  return <>{children}</>
}

export const MatomoProvider: FC<PropsWithChildren> = ({ children }) => {
  const tracker = useMemo(() => getMatomoTracker(), [])

  if (!tracker) {
    return <>{children}</>
  }

  return (
    <JonkoopsMatomoProvider value={tracker}>
      <MatomoTracking>{children}</MatomoTracking>
    </JonkoopsMatomoProvider>
  )
}
